// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description The user associated with the counterparty entity
*/
export class DigitalpaymentCounterpartyUserDetail {
    'counterpartyUserName'?: string | null;
    'counterpartyUserAliasId'?: string | null;
    'counterpartyUserEmailAddress'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DigitalpaymentCounterpartyUserDetail>> = [
        {
            "name":     "counterpartyUserName",
            "baseName": "counterpartyUserName",
            "type":     "string"
        },
        {
            "name":     "counterpartyUserAliasId",
            "baseName": "counterpartyUserAliasId",
            "type":     "string"
        },
        {
            "name":     "counterpartyUserEmailAddress",
            "baseName": "counterpartyUserEmailAddress",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return DigitalpaymentCounterpartyUserDetail.attributeTypeMap;
    }
}
